export const EVENT_LOADING_SHOW = 'event.loading.show';
export const EVENT_LOADING_HIDE = 'event.loading.hide';
export const REDIRECT_TO_HOME = 'event.redirect.home';
export const REDIRECT_TO_404 = 'event.redirect.404';
export const REDIRECT_TO_SELECT_COMPANY = 'event.redirect.company_select';
export const LAN_ENGLISH = 'English';
export const LAN_CHINESE = '简体中文';
export const LAN_SPANISH = 'Español';
export const LAN_JAPANESE = '日本語';
export const LAN_CHINESE_KEY = 'zh-CN';
export const LAN_ENGLISH_KEY = 'en-US';
export const LAN_JAPANESE_KEY = 'ja-JP';
export const LAN_SPANISH_KEY = 'es-ES';
export const LAN_CHINESE_VAR = 'zh_CN';
export const LAN_ENGLISH_VAR = 'en_US';
export const LAN_JAPANESE_VAR = 'ja_JP';
export const LAN_SPANISH_VAR = 'es_ES';
export const USER_TYPE_SESSION_KEY = 'user_permission_type';
export const USER_APP_PERMISSION_SESSION_KEY = 'user_app_permission';
export const WORKING_ORGANIZATION_STORAGE_KEY = 'working_org_key';
export const WORKING_APP_ID_STORAGE_KEY = 'working_app_id';
export const WORKING_MENU_CODE_STORAGE_KEY = 'working_menu_code';
export const VIEW_MODE_STORAGE_KEY = 'view_mode';
export const USER_INFO_STORAGE_KEY = 'current_user_info';
export const ACCESS_TOKEN_SESSION_KEY = 'access_token_key';
export const QUERY_ENTICES_KEY = 'query_entices_key';
export const LOGIN_URL_SESSION_KEY = 'login_url';
export const FRAME_KEY = '__f__';
export const FRAME_VALUE = '__aim__';
export const DISABLE_SOUND_SESSION_KEY = 'disabled_sound';
export const DISABLE_DIALOG_SESSION_KEY = 'disabled_dialog';
export const LATEST_MESSAGE_TIME_STAMP_SESSION_KEY = 'latest_message_time_stamp';
export const BATCH_IMPORT_SESSION_KEY = 'batch_import_latest_record_id';
export const DISABLE_WEBSOCKET_SESSION_KEY = 'disable_websocket';
export const THEME_DARK = 'DARK';
export const THEME_GREEN = 'GREEN';
export const THEME_DEFAULT = 'DARK';
export const DEFAULT_HOMEPAGE = 'default_homepage';
export const BROWSER_OPTION = 'browser_option';
export const BATCH_EXPORT_SESSION_KEY = 'batch_export_latest_record_id';

export const THEME_KEYS = {
  DARK: 'theme-dark',
  GREEN: 'theme-green'
};

export const USER_PERMISSION_TYPE = {
  SUPER_ADMIN: 3,
  OU_ADMIN: 2,
  SUB_ADMIN: 1,
  NORMAL: 0,
  ANONYMOUS: -1
};

export const STATUS_CODE = {
  SUCCESS_BUSINESS: 10000,
  SUCCESS: 200,
  INVALID_PARAMETER: 400,
  UNAUTHENTICATED: 401,
  PERMISSION_DENIED: 403,
  NOT_FOUND: 404,
  ALREADY_EXISTED: 409,
  EXPIRED: 410,
  TOO_LARGE: 414,
  OUT_OF_RANGE: 415,
  EXHAUSTED: 429,
  WRONG_PARAMETER: 430,
  UNVERIFY: 437,
  INTERNAL_ERROR: 500,
  ORGANIZATION_NOT_SELECTED: 512
};

export const APP_PORTAL_SDK = {
  CONSUMER: 'APP_PORTAL_SDK_CONSUMER',
  PROVIDER: 'APP_PORTAL_SDK_PROVIDER'
};

export const USER_DOMAIN_TYPE = {
  DOMAIN: 1,
  INTERNAL: 0,
  UNSET: -1
};

export const ALARM_MESSAGE_LENGTH = 50;

export const ENCOMPASS_ALARM_POPUP = 'alarmPopup';
